import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import SoloStatsCard from "visual-components/quickview/solo-stats-card";
import SoloWinnerCard from "visual-components/quickview/solo-winner-card";

/**
 * Solo Quick View tab content: a trimmed performance summary (Sweeps Visits + Entries + the full
 * analytics link), plus the winner card once the campaign has ended. Visits/entries come straight
 * from the already-loaded campaign stats, so no extra analytics fetch is needed here — the SMS/CTA/
 * revenue breakdown lives behind the "View Full Analytics" link.
 * @param {Object} props
 * @param {Object} props.currentCampaign - The campaign being viewed (from Redux).
 * @param {Function} props.chooseWinner - Opens the pick-winner flow for a completed campaign.
 * @returns {import("react").ReactElement}
 */
function SoloQuickViewSummaryComponent(props) {
  const { currentCampaign, chooseWinner } = props;
  const { id: campaignId, endDate, stats } = currentCampaign;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { totalEntries = 0, totalVisits = 0 } = stats || {};
  const completed = new Date(endDate) < new Date();

  return (
    <div style={{ width: "100%", paddingTop: 20 }}>
      {completed && (
        <SoloWinnerCard currentCampaign={currentCampaign} chooseWinner={chooseWinner} />
      )}
      <SoloStatsCard
        minimal
        loading={false}
        campaignId={campaignId}
        visits={totalVisits}
        entries={totalEntries}
        cta={{}}
        smsSend={{}}
      />
    </div>
  );
}

SoloQuickViewSummaryComponent.propTypes = {
  currentCampaign: PropTypes.object.isRequired,
  chooseWinner: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => {
  const { currentCampaign } = state;
  return { currentCampaign };
};

export const SoloQuickViewSummary = connect(mapStateToProps)(SoloQuickViewSummaryComponent);
